import { omdApi } from 'bus/api';

import { FactoryDetail } from './types';

const factoryApi = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getFactoryDetail: builder.query<FactoryDetail, { id: number } | { id: string }>({
      query: ({ id }) => ({
        url: `/v1/factory/${id}`,
      }),
    }),

    createFactory: builder.mutation<void, FactoryDetail>({
      query: (data) => ({
        url: '/v1/factory/',
        method: 'POST',
        body: data,
      }),
    }),

    editFactory: builder.mutation<void, FactoryDetail>({
      query: (data) => ({
        url: `/v1/factory/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),

    deleteFactory: builder.mutation<void, { id: number | string }>({
      query: ({ id }) => ({
        url: `/v1/factory/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetFactoryDetailQuery,
  useLazyGetFactoryDetailQuery,
  useCreateFactoryMutation,
  useEditFactoryMutation,
  useDeleteFactoryMutation,
} = factoryApi;
